import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';


import { ConfigServerService, CustomHttp } from '../../../../core';
import { TituloReceberResumoFilter } from '../filter/titulo-receber-resumo-filter';
import { TituloReceberResumo} from '../titulo-receber-resumo';

@Injectable({
    providedIn: 'root'
})
export class TituloReceberResumoHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/tituloreceber/0/resumo`
    }

    /** Obtem o resumo dos títulos a receber **/
    getResumo(filter: TituloReceberResumoFilter): Observable<TituloReceberResumo> {
        // Params
        let params = new HttpParams();
        if (filter) {
            params = filter.createParams(params);
        }

        return this.customHttp.get<TituloReceberResumo>(this.pathApi, {params});
    }
}
